import { render, staticRenderFns } from "./RequestAnalysis.vue?vue&type=template&id=b0bab16e&scoped=true&"
import script from "./RequestAnalysis.vue?vue&type=script&lang=js&"
export * from "./RequestAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./RequestAnalysis.vue?vue&type=style&index=0&id=b0bab16e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bab16e",
  null
  
)

export default component.exports